import State from '../../../application/core/State';
import Event from '../../../application/core/Event';
import OrderChangeRequested from '../../../application/order/events/OrderChangeRequested';
import OrderChangeConfirmed from '../../../application/order/events/OrderChangeConfirmed';
import OrderValidationResult from './OrderValidationResult';
import StockError from './error';
import { StockLevelValidatorConfig } from './config';
import OrderValidated from '../../../application/order/events/OrderValidated';

// tslint:disable-next-line:typedef
export default (config: StockLevelValidatorConfig) => (state: State, event: OrderChangeRequested): Event[] => {
    if (event.validate) {
        const result: OrderValidationResult = config[event.field](state, event);
        if (result.notification === StockError.Null) {
            return [new OrderChangeConfirmed(event.product, event.value, event.sku, event.variantCode, event.field)];
        } else {
            return [
                new OrderValidated(result.notification),
                new OrderChangeConfirmed(event.product, result.value, event.sku, event.variantCode, event.field)
            ];
        }
    } else {
        return [new OrderChangeConfirmed(event.product, event.value, event.sku, event.variantCode, event.field)];
    }
};



// WEBPACK FOOTER //
// ./src/domain/orders/validators/checkOrderValue.ts